import { Component, OnInit } from '@angular/core';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { NotificationService } from './services/notification/notification.service';
import { AuthService } from './services/auth/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  public openedSidenav$: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);

  title = 'trainer-app-web';

  constructor() {}

  public openCloseSidenav(openedSidenav: boolean): void {
    this.openedSidenav$.next(openedSidenav);
  }
}
